module.exports = __webpack_public_path__ + "./images/p8.JPG?7f4435e56e2a2e92a5390cb7068b770d";


//////////////////
// WEBPACK FOOTER
// ./src/products/p8.JPG
// module id = 71
// module chunks = 0